<ng-container>
  <section id="branches">
    <app-branch-list></app-branch-list>
  </section>

    <section id="positions">
        <app-company-positions-list></app-company-positions-list>
    </section>
</ng-container>
